/**
 * Безопасный разбор ответа API: не бросает SyntaxError при HTML/502 от Nginx.
 */
export type ParseJsonResult<T> =
  | { ok: true; data: T }
  | { ok: false; error: string };

export async function parseJsonResponse<T = unknown>(
  response: Response
): Promise<ParseJsonResult<T>> {
  const text = await response.text();
  const status = response.status;
  const contentType = (response.headers.get('content-type') || '').toLowerCase();

  if (!text.trim()) {
    return {
      ok: false,
      error: `Пустой ответ сервера (HTTP ${status}). Возможен таймаут прокси или code-executor не запущен.`,
    };
  }

  const looksHtml =
    text.trimStart().startsWith('<') ||
    text.includes('<!DOCTYPE') ||
    (!contentType.includes('json') && contentType.includes('text/html'));

  if (looksHtml) {
    return {
      ok: false,
      error:
        `Сервер вернул HTML вместо JSON (HTTP ${status}). ` +
        `Проверьте Nginx: location для /execute и /submit* → 127.0.0.1:5001, proxy_read_timeout ≥ 300s.`,
    };
  }

  try {
    return { ok: true, data: JSON.parse(text) as T };
  } catch {
    return {
      ok: false,
      error: `Невалидный JSON (HTTP ${status}): ${text.slice(0, 240)}`,
    };
  }
}
